function createNexInLineCards() {
    const arr = nextVideosData;
    const cards = arr.map(
        (item) =>
            `<a href="${
                item.pageLink +
                (item.pageLink.includes('?') ? '&' : '?') +
                'scrollToVideoPlayer=true'
            }" class="embla__slide training-card w-314">
            <div class="training-card__img-wrap">
                <img src="${
                    item.image
                }" alt="video poster" class="training-card__img">
            </div>
            <div class="training-card__info">
                <div>
                    ${
                        item.trail != ''
                            ? `<div class='fz-12-16 fw-600 c-orange'>${item.trail}</div>`
                            : ''
                    }
                    <div class='df fbc gap-16'>
                        <div class='fz-15-26 fw-700 c-orange'>${item.tod}</div>
                        <div class='fz-12-16 fw-600 c-gray-6'>${item.date}</div>
                    </div>
                </div>
                ${
                    item.name != '' || item.bib != '' || item.time != ''
                        ? `<div class='h-1 bg-c-gray-2'></div>
                        <div class='df fbs gap-8 fz-12-16 fw-600'>
                            ${
                                item.name != ''
                                    ? `<div class='fw'>
                                        <div class='c-gray-6'>Name</div>
                                        <div class='c-dark'>${item.name}</div>
                                    </div>`
                                    : ''
                            }
                            ${
                                item.bib != ''
                                    ? `<div class='w-22p flex-shrink-0'>
                                    <div class='c-gray-6'>BIB</div>
                                    <div class='c-dark'>${item.bib}</div>
                                </div>`
                                    : ''
                            }
                            ${
                                item.time != ''
                                    ? `<div class='w-22p flex-shrink-0 ta-r'>
                                    <div class='c-gray-6'>Time</div>
                                    <div class='c-dark'>${item.time}</div>
                                </div>`
                                    : ''
                            }
                        </div>`
                        : ''
                }
            </div>
        </a>`
    );

    const layout = $(`.js-next-in-line-wrapper`).append(cards);
    $(document).trigger('layoutForEmblaIsCreated');
    return layout;
}

runIfElementExist(createNexInLineCards, '.js-next-in-line-wrapper');

function startNextInLineEmbla() {
    const rootNode = document.querySelector('.js-video-next-in-line-embla');
    const viewportNode = rootNode.querySelector('.embla__viewport');
    const options = { loop: false };
    const emblaApi = EmblaCarousel(viewportNode, options);

    const prevBtnNode = document.querySelector('.embla__prev');
    const nextBtnNode = document.querySelector('.embla__next');

    prevBtnNode.addEventListener('click', emblaApi.scrollPrev, false);
    nextBtnNode.addEventListener('click', emblaApi.scrollNext, false);

    const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
        const togglePrevNextBtnsState = () => {
            if (emblaApi.canScrollPrev()) prevBtn.removeAttribute('disabled');
            else prevBtn.setAttribute('disabled', 'disabled');

            if (emblaApi.canScrollNext()) nextBtn.removeAttribute('disabled');
            else nextBtn.setAttribute('disabled', 'disabled');
        };

        emblaApi
            .on('select', togglePrevNextBtnsState)
            .on('init', togglePrevNextBtnsState)
            .on('reInit', togglePrevNextBtnsState);

        return () => {
            prevBtn.removeAttribute('disabled');
            nextBtn.removeAttribute('disabled');
        };
    };

    const addPrevNextBtnsClickHandlers = (emblaApi, prevBtn, nextBtn) => {
        const scrollPrev = () => {
            emblaApi.scrollPrev();
        };
        const scrollNext = () => {
            emblaApi.scrollNext();
        };
        prevBtn.addEventListener('click', scrollPrev, false);
        nextBtn.addEventListener('click', scrollNext, false);

        const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
            emblaApi,
            prevBtn,
            nextBtn
        );

        return () => {
            removeTogglePrevNextBtnsActive();
            prevBtn.removeEventListener('click', scrollPrev, false);
            nextBtn.removeEventListener('click', scrollNext, false);
        };
    };

    addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode);
}

$(document).on('layoutForEmblaIsCreated', function () {
    startNextInLineEmbla();
});
